import { apiGet, apiPut } from './client'

export interface UserPreferences {
  theme: string
  background_url: string | null
}

export async function fetchPreferences() {
  return apiGet<{ data: UserPreferences }>('/preferences')
}

export async function updatePreferences(data: Partial<UserPreferences>) {
  return apiPut<{ data: UserPreferences }, Partial<UserPreferences>>('/preferences', data)
}
